import React from 'react';
import { StyledToastContainer } from './ToastContainer.styled';
import { useTheme } from '@mui/material';

export const CustomToastContainer = () => {
  const theme = useTheme();

  return <StyledToastContainer theme={theme.palette.mode} />;
};
